import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";

import { PRODUCT_FRAGMENT } from "../../../component/productPreview/ProductPreview";
import ProductsListItem from "../../../component/productsList/productsListItem/ProductsListItem";
import { PRODUCT_LIST_ITEM_FRAGMENT } from '../../../query/productFragments';

import "./WeLove.css";

const LIMIT = 30;

const WE_LOVE_PRODUCTS = gql`
  query WeLove($offset: Int, $limit: Int) {
    items: getCollectionProducts(
      collection_id: 1
      offset: $offset
      limit: $limit
    ) {
      ...ProductFragment
      ...ProductListItemFragment
      price
    }
  }
  ${PRODUCT_FRAGMENT}
  ${PRODUCT_LIST_ITEM_FRAGMENT}
`;

/**
 * 홈화면 We Love 섹션
 * @returns {JSX.Element}
 * @constructor
 */
export default function WeLove() {
  const [extraItems, setExtraItems] = useState([]);

  const { data, loading, fetchMore } = useQuery(WE_LOVE_PRODUCTS, {
    variables: { offset: 0, limit: LIMIT },
    fetchPolicy: "cache-and-network",
  });

  const baseItems = data?.items ?? [];
  const allItems = [...baseItems, ...extraItems];
  const hasMore =
    !loading && allItems.length > 0 && allItems.length % LIMIT === 0;

  const handleLoadMore = async () => {
    const result = await fetchMore({
      variables: { offset: allItems.length, limit: LIMIT },
    });
    if (result.data?.items) {
      setExtraItems((prev) => [...prev, ...result.data.items]);
    }
  };

  return (
    <section className="WeLove">
      <div className="WeLove-inner">
        <div className="WeLove-header">
          <div>
            <div className="WeLove-tag">WE LOVE</div>
            <h2 className="WeLove-title">지금 사랑받는 아이템</h2>
          </div>
        </div>
        <div className="WeLove-grid">
          {allItems.map((product) => (
            <ProductsListItem key={product.id} product={product} />
          ))}
        </div>
        {hasMore && (
          <div className="WeLove-load-more-wrap">
            <button
              className="WeLove-load-more"
              onClick={handleLoadMore}
              disabled={loading}
            >
              {loading ? "로딩 중..." : "더보기"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
